import { FlightNodeViewModel, FlightViewModel } from '@api/v3';
import { getFlightInfoFromSegment } from '@components/views/flight/listing/components/Flight/utils';
import { FlightSummaryProps } from '@components/views/flight/types';

export const FLIGHT_DIRECTION = {
  DEPARTURE: 0,
  RETURN: 1,
};

export const FLIGHT_PROVIDERS = {
  AJ: 'Anadolu Jet',
  PC: 'Pegasus',
  TK: 'Turkish Airlines',
};

export type FlightProps = {
  domestic: boolean;
  summary: FlightSummaryProps;
  flights: Array<FlightNodeViewModel>;
  orginalItem: FlightViewModel;
} & FlightNodeViewModel;

const getFlightSummary = ({
  durationTime,
  provider,
  providerLogo,
  providerName,
  baggage,
  segments = [],
  token,
}: FlightNodeViewModel & { token: string }): FlightSummaryProps => {
  const numberOfStops = segments.length - 1;
  const partialFlightInfo = getFlightInfoFromSegment(
    segments[0],
    segments[segments.length - 1],
    numberOfStops,
    token
  );

  const flightInfo: FlightSummaryProps = {
    ...partialFlightInfo,
    durationTime,
    providerAirline: provider,
    providerAirlineName: providerName,
    providerAirlineLogo: providerLogo,
    baggage,
  };

  return flightInfo;
};

export const selectFlight = (item: FlightViewModel) => {
  const flights = item.flights;
  const token = item.token;
  const domestic = item.domestic;

  const items = {
    summary: getFlightSummary({
      ...flights[0],
      token,
    }),
    ...flights[0],
    domestic,
    flights,
  };
  return { ...items, orginalItem: item };
};
